import { includes } from 'lodash-es'

export function isEnumValue<T extends Record<string, string | number>>(
  enumObject: T,
  value: unknown,
): value is T[keyof T] {
  return includes(Object.values(enumObject), value)
}
